import { render, staticRenderFns } from "./DataTableGroup.vue?vue&type=template&id=7fd30477&"
import script from "./DataTableGroup.vue?vue&type=script&lang=js&"
export * from "./DataTableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports